type HapticType = 'light' | 'medium' | 'heavy' | 'soft' | 'rigid' | 'selection' | 'success' | 'warning' | 'error';

// Safari on iOS 18+ triggers haptic feedback when a <input type="checkbox" switch> is toggled.
// We keep a persistent off-screen element and click its label to trigger the haptic each time.
// The element must not use display:none — it needs to be rendered for the haptic to fire.
let safariHapticLabel: HTMLLabelElement | null = null;

function ensureSafariHapticElement() {
  if (safariHapticLabel && document.body.contains(safariHapticLabel)) return;
  const label = document.createElement('label');
  label.ariaHidden = 'true';
  label.style.position = 'fixed';
  label.style.top = '-100px';
  label.style.left = '-100px';
  label.style.opacity = '0';
  label.style.pointerEvents = 'none';
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.setAttribute('switch', '');
  label.appendChild(input);
  document.body.appendChild(label);
  safariHapticLabel = label;
}

function safariHaptic() {
  ensureSafariHapticElement();
  safariHapticLabel!.click();
}

const hasNativeHandler = !!(window as any).webkit?.messageHandlers?.hapticFeedback;
const isTouchDevice = typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)')?.matches;

export function haptic(type: HapticType = 'medium') {
  if (hasNativeHandler) {
    // Native iOS app wrapper
    (window as any).webkit.messageHandlers.hapticFeedback.postMessage(type);
  } else if (isTouchDevice) {
    // Fallback for Safari on iOS (no native wrapper)
    safariHaptic();
  }
}
